import React from 'react';
import TownAutocomplete from '../../../shared/components/inputs/TownAutocomplete';

function JobFilters({ categories, towns, selectedCategory, selectedTown, onCategoryChange, onTownChange }) {
  return (
    <div className="rounded-3xl bg-white p-6 shadow-sm space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Category</label>
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-2 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100"
          >
            <option value="">All Categories</option>
            {categories.map((cat) => (
              <option key={cat.id || cat} value={cat.name || cat}>
                {cat.name || cat}
              </option>
            ))}
          </select>
        </div>

        <TownAutocomplete
          id="job-filter-town"
          label="Town"
          value={selectedTown}
          onChange={onTownChange}
          towns={towns}
          required={false}
          placeholder="All towns"
          inputClassName="w-full rounded-2xl border border-slate-300 bg-white px-4 py-2 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100"
        />
      </div>
    </div>
  );
}

export default JobFilters;
